{
	"all": "Todo",
	"emptyMessage": "No se han encontrado productos",
	"mountable": "Producto compuesto",
	"price": "Precio",
	"product": "Producto",
	"sku": "SKU"
}
